<h4 class="fw-bold">
    {{ "user_roles.title" | translate }}
    <span class="fw-light mx-1">
        @if (displayLabel) {
            - {{ displayLabel }}
        }
    </span>
</h4>

<div class="bg-card shadow rounded p-2 mb-2">
    <form class="col-12" [formGroup]="userRolesForm">
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameAE' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && userRolesForm.get('nameAE')?.invalid!"
                    formControlName="nameAE"
                    controlName="nameAE"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameEN' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && userRolesForm.get('nameEN')?.invalid!"
                    formControlName="nameEN"
                    controlName="nameEN"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionAE' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && userRolesForm.get('dscAE')?.invalid!"
                    formControlName="dscAE"
                    controlName="dscAE"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionEN' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="submitted && userRolesForm.get('dscEN')?.invalid!"
                    formControlName="dscEN"
                    controlName="dscEN"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12 my-2">
                <adaa-form-checkbox
                    [label]="'common.form.label.active' | translate"
                    checkboxMode="yesNo"
                    controlName="enabled"
                    formControlName="enabled"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12 my-2">
                <adaa-form-checkbox
                    [label]="'common.form.label.pmo_role' | translate"
                    checkboxMode="yesNo"
                    controlName="isPmoRole"
                    formControlName="isPmoRole"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12 my-2">
                <adaa-form-checkbox
                    [label]="'user_roles.allow_external' | translate"
                    checkboxMode="yesNo"
                    controlName="allowExternal"
                    formControlName="allowExternal"
                />
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12 my-2">
                <adaa-form-checkbox
                    [label]="'user_roles.allow_participating' | translate"
                    checkboxMode="yesNo"
                    controlName="allowParticipating"
                    formControlName="allowParticipating"
                />
            </div>
        </div>
    </form>
</div>

<div class="bg-card shadow rounded p-2 mb-2">
    <div class="d-flex gap-5 my-2">
        <div
            class="position-relative d-flex justify-content-start mt-2"
            [class.me-4]="AdaaHelper.getCurrentLang() === Language.Arabic"
            [class.ms-4]="AdaaHelper.getCurrentLang() !== Language.Arabic"
        >
            <ul class="nav nav-pills pill-switch nav-fill gap-2 p-1 small rounded-5 shadow w-auto" id="pillNav2" role="tablist">
                <li class="nav-item" role="presentation" (click)="pmoOnly.set(false)">
                    <a class="nav-link px-4 active rounded-5" id="home-tab2" data-bs-toggle="tab" type="button" role="tab" aria-selected="true">
                        {{ "common.form.label.general_use" | translate }}
                    </a>
                </li>

                <li class="nav-item" role="presentation" (click)="pmoOnly.set(true)">
                    <a class="nav-link px-4 rounded-5" id="profile-tab2" data-bs-toggle="tab" type="button" role="tab" aria-selected="false">
                        {{ "common.form.label.pmo_only" | translate }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div [class.disabled]="isViewMode()">
        <adaa-user-roles-manager
            [data]="filteredPermissions()"
            [isPmo]="pmoOnly()"
            [pageMode]="pageMode()"
            (setPermissions)="setPermissions($event)"
            (selectAll)="selectAll($event.event, $event.value)"
        />
    </div>
</div>

<div class="my-2">
    <adaa-form-action-buttons
        [showSaveButton]="!isViewMode()"
        saveButtonTitle="common.form.button.submit"
        [cancelButtonTitle]="isViewMode() ? 'common.form.button.close' : 'common.form.button.cancel'"
        (cancelClicked)="close()"
        (saveClicked)="submit()"
    />
</div>
